export { default } from './backgroundImage'
